import _get from "lodash/get";
/**
 * @module lib/helpers
 */
import { LOAN_PROGRAM_FIXED_30, LOAN_PROGRAM_FIXED_20, LOAN_PROGRAM_FIXED_15, LOAN_PROGRAM_FIXED_10, LOAN_TYPE_CONVENTIONAL, LOAN_TYPE_FHA, LOAN_TYPE_VA, VETERAN_TYPE_MILITARY, VETERAN_TYPE_NATIONAL_GUARD } from '@nerdwallet/home-constants';
import { MAX_FHA_CREDIT_SCORE, MIN_PERCENT_DOWN_FHA, MIN_PERCENT_DOWN_CONVENTIONAL } from '../data/constants';
import costsModel from '../data/costs-model.json';

/**
 * Returns the number of monthly payments the user will have to make.
 *
 * It depends on the loanTerm which defaults to 30.
 * @returns {number}
 */
export function getLoanTermMonths(loanTerm) {
  return loanTerm * 12;
}

/**
 * Safely gets a cost from the costs-model. Defaults to California model if given unknown state
 * @param {string} stateAbbr  2 character US state abbreviation
 * @param {string} key Property name of the requested cost
 * @returns {number}
 */
export function getCostForState(stateAbbr, key) {
  var costsModelForState = _get(costsModel, stateAbbr, costsModel.CA);
  return _get(costsModelForState, key, 0);
}
export function getLoanType(_ref) {
  var creditScore = _ref.creditScore,
    veteranType = _ref.veteranType;
  if (veteranType === VETERAN_TYPE_MILITARY || veteranType === VETERAN_TYPE_NATIONAL_GUARD) {
    return LOAN_TYPE_VA;
  }
  return creditScore > MAX_FHA_CREDIT_SCORE ? LOAN_TYPE_CONVENTIONAL : LOAN_TYPE_FHA;
}

/**
 * Helper to derive the down payment to loan amount ratio, needed by calculations and helpful
 * because we usually talk about down payment as a percent of purchase; In essense:
 * downpayment + maxLoanNoInsurance = 100% (suggested)
 * downpayment = 20% of suggested
 * maxLoanNoInsurance = 80% of suggested
 * So, downpayment = 25% of maxLoanInsurance => 20%/80% = 25%.
 *
 * This also makes it plausible to change the suggested down payment percent
 * @param {number} downPaymentPercent down payment percent
 * @returns {number} Loan to down payment ratio
 */
export function getLoanToDownPayment(downPaymentPercent) {
  return downPaymentPercent / (1 - downPaymentPercent);
}
export function getMinDownPayment(_ref2) {
  var loanAmount = _ref2.loanAmount,
    loanType = _ref2.loanType;
  if (loanType === LOAN_TYPE_VA) {
    return 0;
  }
  if (loanType === LOAN_TYPE_FHA) {
    return loanAmount * getLoanToDownPayment(MIN_PERCENT_DOWN_FHA);
  }
  return loanAmount * getLoanToDownPayment(MIN_PERCENT_DOWN_CONVENTIONAL);
}

/**
 * Gets fixed-rate program according to number of years in loan term
 * @param {Number} loanTerm Loan term in years
 * @return {external:home-constants.LOAN_PROGRAM}
 */
export function getLoanProgramFromTerm(loanTerm) {
  switch (loanTerm) {
    case 10:
      return LOAN_PROGRAM_FIXED_10;
    case 15:
      return LOAN_PROGRAM_FIXED_15;
    case 20:
      return LOAN_PROGRAM_FIXED_20;
    case 30:
    default:
      return LOAN_PROGRAM_FIXED_30;
  }
}